<template>
  <v-card style="border-radius: 1em;">
    <v-card-title>
      <h2>Solicitação de Adição de Crédito</h2>
    </v-card-title>
    <v-card-text>
      <v-layout wrap>
        <v-flex xs5>
        {{`${
              compraCredito.individuo.administrador ? `Empresa: ${
                compraCredito.individuo.nome_fantasia
              }` : compraCredito.individuo.representante ? `Posto  ${
                compraCredito.individuo.nome_fantasia
              }` : `Usuário: ${
                compraCredito.individuo.nome
              } ${compraCredito.individuo.sobrenome}`
            }`}}
        </v-flex>
        <v-flex xs5>
          {{`${
              compraCredito.individuo.administrador || compraCredito.individuo.representante ? `CNPJ: ${
                compraCredito.individuo.cnpj
              }` : `CPF: ${
                compraCredito.individuo.nome
              } ${compraCredito.individuo.sobrenome}`
            }`}}
        </v-flex>
        <v-flex xs5>
          Valor para adicionar: {{compraCredito.valor | currency({fractionCount: 2})}}
        </v-flex>
        <v-flex xs5>
          Data: {{compraCredito.data | formatDate('DD/MM/YYYY')}}
        </v-flex>
        <v-layout column class="pa-0 ma-0 mt-3 mb-3">
            <v-flex align-self-center class="pa-0 ma-0">
                <v-img contain v-if="imagemAnexada" :src="imagemAnexada" alt="imagem do comprovante" width="500" class="pa-0 ma-0"/>
                <object v-if="arquivoAnexado" width="500" height="600" type="application/pdf" :data="arquivoAnexado"></object>
                <v-card v-if="!imagemAnexada && !arquivoAnexado" color="grey" width="400" height="400">
                    <v-layout justify-center align-center fill-height>
                        <div class="title white--text pa-4 text-xs-center">Sem comprovante anexado</div>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
      </v-layout>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn color="primary" class="mb-3" round @click="dialog = true">Histórico da Carteira</v-btn>
    </v-card-actions>
    <v-card-actions class="justify-space-around">
      <v-btn color="error" class="mb-3" round @click="responderSolicitacao(false)">Rejeitar</v-btn>
      <v-btn color="success" class="mb-3" round @click="responderSolicitacao(true)">Aceitar</v-btn>
    </v-card-actions>
    <v-dialog v-model="dialog" v-if="dialog" width="500" scrollable>
        <historico-carteira
          :posto="compraCredito.individuo.representante ? compraCredito.individuo: undefined"
          :empresa="compraCredito.individuo.administrador ? compraCredito.individuo: undefined"
          :pessoa="!compraCredito.individuo.representante && !compraCredito.individuo.administrador ? compraCredito.individuo: undefined"
          @fechar="dialog = false"
        />
    </v-dialog>
  </v-card>
</template>

<script>

import HistoricoCarteira from '@/components/dialogs/HistoricoCarteira'

export default {
  props: ['compraCredito'],
  components: { HistoricoCarteira },
  data: () => ({
    imagemAnexada: null,
    arquivoAnexado: null,
    dialog: false
  }),
  mounted () {
      if (this.compraCredito && this.compraCredito.comprovante) {
          if (this.compraCredito.comprovante.indexOf('png') === -1) {
        this.arquivoAnexado = this.compraCredito.comprovante
      } else {
        this.imagemAnexada = this.compraCredito.comprovante
      }
    }
  },
  methods: {
    responderSolicitacao (resposta) {
      this.$store.dispatch('adicaoDeCredito', {
        method: 'PUT',
        resposta: resposta,
        id: this.compraCredito.id
      }).then(() => {
        this.$emit('success', `Solicitação ${resposta ? 'aceita' : 'rejeitada'} com sucesso.`)
        this.$emit('carregarNotificacoes')
        this.$emit('fechar')
      })
    }
  }
}
</script>
